import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/iesifp-logo.svg'
import _imports_1 from '@/assets/european-regional-development.svg'
import _imports_2 from '@/assets/logo-local-authorities.jpg'
import _imports_3 from '@/assets/logo-ei.png'
import _imports_4 from '@/assets/leo-logo.svg'
import _imports_5 from '@/assets/meen-logo.svg'


const _hoisted_1 = { id: "butter" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "header-actions" }
const _hoisted_12 = {
  key: 0,
  class: "account-button"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "ic ic-user" }, null, -1)
const _hoisted_14 = { class: "account-menu" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "ic ic-profile" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "ic ic-work" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "ic ic-logout" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "ic ic-login" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "ic ic-menu l" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["open"]
const _hoisted_22 = { class: "nav-item" }
const _hoisted_23 = { class: "nav-item" }
const _hoisted_24 = { class: "nav-item" }
const _hoisted_25 = { class: "nav-item" }
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = { class: "nav-item" }
const _hoisted_28 = { class: "nav-item" }
const _hoisted_29 = { class: "nav-item" }
const _hoisted_30 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_31 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_32 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_33 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_34 = { class: "page-container" }
const _hoisted_35 = { class: "newsletter" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "column-left animated-block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "content-text" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "Join our newsletter"),
      /*#__PURE__*/_createElementVNode("p", null, "Stay updated on all the latest news and upcoming events. Just enter your email, and we'll keep you in the loop!")
    ])
  ])
], -1)
const _hoisted_37 = { class: "column-right animated-block" }
const _hoisted_38 = { class: "content" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { for: "newsletter-email" }, "Enter your email below to receive all updates from our network!", -1)
const _hoisted_41 = { class: "input-button" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "field checkbox" }
const _hoisted_45 = ["checked", "disabled"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("I have read and agree to the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/privacy-policy",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Data Privacy Policy")
], -1)
const _hoisted_47 = {
  key: 0,
  class: "success-message"
}
const _hoisted_48 = {
  key: 1,
  class: "success-message error"
}
const _hoisted_49 = /*#__PURE__*/_createStaticVNode("<section class=\"partners\"><div class=\"wrapper\"><div class=\"container\"><div class=\"logo-container animated-block\"><img src=\"" + _imports_0 + "\" alt=\"\" class=\"logo\"></div><div class=\"logo-container animated-block\"><img src=\"" + _imports_1 + "\" alt=\"\" class=\"logo\"></div><div class=\"logo-container animated-block\"><img src=\"" + _imports_2 + "\" alt=\"\" class=\"logo\"></div><div class=\"logo-container animated-block\"><img src=\"" + _imports_3 + "\" alt=\"\" class=\"logo\"></div><div class=\"logo-container animated-block\"><img src=\"" + _imports_4 + "\" alt=\"\" class=\"logo\"></div></div></div></section>", 1)
const _hoisted_50 = { class: "join-network animated-block" }
const _hoisted_51 = { class: "wrapper" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Be part of the Engenuity Network", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "ic ic-arrow-right" }, null, -1)
const _hoisted_54 = { class: "wrapper" }
const _hoisted_55 = { class: "container" }
const _hoisted_56 = { class: "column animated-block" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "column-header" }, "Menu", -1)
const _hoisted_58 = /*#__PURE__*/_createStaticVNode("<div class=\"column animated-block\"><div class=\"column-header\">Connect</div><a href=\"https://www.facebook.com/profile.php?id=100063737761079\" target=\"_blank\" rel=\"noopener noreferrer\">Facebook</a><a href=\"https://www.linkedin.com/in/engenuity-midlands-engineering-network-1a30881aa/\" target=\"_blank\" rel=\"noopener noreferrer\">LinkedIn</a><a href=\"https://x.com/Engenuity2\" target=\"_blank\" rel=\"noopener noreferrer\">X</a></div>", 1)
const _hoisted_59 = { class: "column animated-block" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "column-header" }, "Info", -1)
const _hoisted_61 = { class: "column animated-block" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "column-header" }, "Legal", -1)
const _hoisted_63 = { class: "footer-bottom" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "Midlands Engineering Network",
  class: "footer-logo animated-block"
}, null, -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "footer-copyright animated-block" }, "© Midlands Engineering Network 2024. All rights reserved.", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "footer-sign animated-block" }, [
  /*#__PURE__*/_createTextVNode("Made with ❤️ by "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://blackpugstudio.com",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Black Pug Studio")
], -1)

import { nextTick, onMounted, ref, watch } from 'vue';
import { httpsCallable } from 'firebase/functions'
import { auth, functions } from '@/services/FirebaseService';
import ResourcesSection from './components/ResourcesSection.vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { signOut } from 'firebase/auth';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();
const newsletterSuccess = ref(false);
const loading = ref(false);
const navOpen = ref(false);
const newsletterError = ref('');
const newsletterModel = ref({
  email: '',
  tos: false,
});

const logout = () => signOut(auth);

const joinNewsletter = async () => {
  loading.value = true;
  newsletterSuccess.value = false;
  newsletterError.value = '';
  try {
    const { email, tos } = newsletterModel.value;
    if (!tos) {
      throw new Error('You must agree to our data privacy policy to subscribe to our newsletter.');
    }
    await httpsCallable(functions, 'joinNewsletter')({ email });
    newsletterSuccess.value = true;
    newsletterModel.value = {
      email: '',
      tos: false,
    };
  } catch (error: any) {
    console.log(error);
    newsletterError.value = error.message;
    loading.value = false;
  }
};

const observer = new IntersectionObserver((entries) => {
  let index = 0;
  entries.forEach((entry) => {
    if (entry.isIntersecting && !entry.target.classList.contains('animate')) {
      index++;
      (entry.target as HTMLElement).style.transitionDelay = `${index * 200}ms`;
      nextTick(() => {
        entry.target.classList.add('animate');
      });
    }
  });
});

setInterval(() => {
  const blocks = document.querySelectorAll('.animated-block:not(.observe)');
  blocks.forEach((block) => {
    block.classList.add('observe');
    observer.observe(block);
  });
}, 250);

watch([store.state, route], () => {
  if (store.state.user?.company_name && route.name && ['login', 'register'].includes(route.name.toString())) {
    router.push('/account/profile');
  } else if (store.state.user === null && route.name && route.name.toString().startsWith('account')) {
    router.push('/login');
  }
});

const closeNav = () => {
  navOpen.value = false;
};

onMounted(() => {
  window.addEventListener('click', closeNav);
  const hasTouch = ('ontouchstart' in document.documentElement);
  if (!hasTouch) {
    (window as any).butter.init();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: `/images/meen-logo${['/news', '/events'].includes(_ctx.$route.path) ? '-w' : ''}.svg`,
              alt: "Midlands Engineering Network",
              class: "header-logo"
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        }),
        _createElementVNode("nav", null, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createTextVNode("Home")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/members" }, {
              default: _withCtx(() => [
                _createTextVNode("Members")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, { to: "/events" }, {
              default: _withCtx(() => [
                _createTextVNode("Events")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, { to: "/news" }, {
              default: _withCtx(() => [
                _createTextVNode("News")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, { to: "/jobs" }, {
              default: _withCtx(() => [
                _createTextVNode("Jobs")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_router_link, { to: "/resources" }, {
              default: _withCtx(() => [
                _createTextVNode("Resources")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, { to: "/about" }, {
              default: _withCtx(() => [
                _createTextVNode("About")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_unref(store).state.user?.company_name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_router_link, {
                  to: "/account/profile",
                  class: "link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _createTextVNode(" My Account ")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_router_link, {
                    to: "/account/profile",
                    class: "link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15,
                      _createTextVNode(" Company Profile ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/account/jobs",
                    class: "link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16,
                      _createTextVNode(" Job Openings ")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("a", {
                    class: "link",
                    onClick: logout
                  }, [
                    _hoisted_17,
                    _createTextVNode(" Log out ")
                  ])
                ])
              ]))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "/login",
                class: "link"
              }, {
                default: _withCtx(() => [
                  _hoisted_18,
                  _createTextVNode(" Log in ")
                ]),
                _: 1
              })),
          _createVNode(_component_router_link, {
            class: "btn",
            to: "/contact"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Contact")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("button", {
          class: "mobile-nav-button",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (navOpen.value = !navOpen.value), ["stop"]))
        }, _hoisted_20),
        _createElementVNode("div", {
          class: "mobile-nav",
          open: navOpen.value || null
        }, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createTextVNode("Home")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_router_link, { to: "/members" }, {
              default: _withCtx(() => [
                _createTextVNode("Members")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_router_link, { to: "/events" }, {
              default: _withCtx(() => [
                _createTextVNode("Events")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_router_link, { to: "/news" }, {
              default: _withCtx(() => [
                _createTextVNode("News")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_router_link, { to: "/jobs" }, {
              default: _withCtx(() => [
                _createTextVNode("Jobs")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_router_link, { to: "/resources" }, {
              default: _withCtx(() => [
                _createTextVNode("Resources")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_router_link, { to: "/about" }, {
              default: _withCtx(() => [
                _createTextVNode("About")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_router_link, { to: "/contact" }, {
              default: _withCtx(() => [
                _createTextVNode("Contact")
              ]),
              _: 1
            })
          ]),
          (_unref(store).state.user?.company_name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createVNode(_component_router_link, { to: "/account/profile" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Company Profile")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_unref(store).state.user?.company_name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createVNode(_component_router_link, { to: "/account/jobs" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Job Openings")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_unref(store).state.user?.company_name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("a", { onClick: logout }, " Log out ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createVNode(_component_router_link, { to: "/login" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Log in")
                  ]),
                  _: 1
                })
              ]))
        ], 8, _hoisted_21)
      ])
    ]),
    _createElementVNode("main", _hoisted_34, [
      _createVNode(_component_router_view)
    ]),
    (!['/resources', '/contact', '/about', '/register'].includes(_ctx.$route.path))
      ? (_openBlock(), _createBlock(ResourcesSection, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_35, [
      _hoisted_36,
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("form", {
            class: "newsletter-form",
            disabled: loading.value || null,
            onSubmit: _withModifiers(joinNewsletter, ["prevent"])
          }, [
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              _withDirectives(_createElementVNode("input", {
                placeholder: "email",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newsletterModel.value.email) = $event)),
                disabled: loading.value,
                class: "input",
                type: "email",
                id: "newsletter-email",
                maxlength: "255",
                required: ""
              }, null, 8, _hoisted_42), [
                [_vModelText, newsletterModel.value.email]
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "btn dark",
                disabled: loading.value
              }, "Sign me up", 8, _hoisted_43)
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("button", {
                class: "checkbox",
                type: "button",
                checked: newsletterModel.value.tos || null,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (newsletterModel.value.tos = !newsletterModel.value.tos)),
                disabled: loading.value
              }, null, 8, _hoisted_45),
              _hoisted_46
            ]),
            (newsletterSuccess.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, "Thank you for subscribing to our newsletter!"))
              : (newsletterError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(newsletterError.value), 1))
                : _createCommentVNode("", true)
          ], 40, _hoisted_39)
        ])
      ])
    ]),
    _hoisted_49,
    _createElementVNode("section", _hoisted_50, [
      _createElementVNode("div", _hoisted_51, [
        _hoisted_52,
        _createVNode(_component_router_link, {
          class: "btn dark",
          to: "/register"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Join the network "),
            _hoisted_53
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _hoisted_57,
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createTextVNode("Home")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/members" }, {
              default: _withCtx(() => [
                _createTextVNode("Members")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/events" }, {
              default: _withCtx(() => [
                _createTextVNode("Events")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/news" }, {
              default: _withCtx(() => [
                _createTextVNode("News")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/jobs" }, {
              default: _withCtx(() => [
                _createTextVNode("Jobs")
              ]),
              _: 1
            })
          ]),
          _hoisted_58,
          _createElementVNode("div", _hoisted_59, [
            _hoisted_60,
            _createVNode(_component_router_link, { to: "/resources" }, {
              default: _withCtx(() => [
                _createTextVNode("Resources")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/about" }, {
              default: _withCtx(() => [
                _createTextVNode("About")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/contact" }, {
              default: _withCtx(() => [
                _createTextVNode("Contact")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            _createVNode(_component_router_link, { to: "/privacy-policy" }, {
              default: _withCtx(() => [
                _createTextVNode("Privacy Policy")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/terms-conditions" }, {
              default: _withCtx(() => [
                _createTextVNode("Terms & Conditions")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_63, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_64
            ]),
            _: 1
          }),
          _hoisted_65,
          _hoisted_66
        ])
      ])
    ])
  ]))
}
}

})